/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../NatsCaller";
import type { EmptyResponse, MoveToTeamRequest, RemoveStickyRequest } from "./models";
import { emptyResponseSchema } from "./schemas";

export class NatsStickyClient {
  constructor(private caller: NatsCaller) {}

  async removeSticky(payload: RemoveStickyRequest, sticky_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.sticky.v1.stickies.${sticky_id}.delete".replace(
        "${sticky_id}",
        sticky_id,
      );
    return await this.caller.request(subject, "removeSticky", payload, emptyResponseSchema);
  }

  async moveToTeam(payload: MoveToTeamRequest, sticky_id: string): Promise<EmptyResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.sticky.v1.stickies.${sticky_id}.move".replace(
      "${sticky_id}",
      sticky_id,
    );
    return await this.caller.request(subject, "moveToTeam", payload, emptyResponseSchema);
  }
}
